export default function Go_Logical () {
  return (
    <div>
      <h1>Go_Logical </h1>
      <p>Logical</p>
    </div>
  );
}